var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-bottom-buttons"},[_c('a',{staticClass:"btn-green-gradient",attrs:{"href":_vm.notificationsPath}},[_vm._v("Смотреть все")])])}
var staticRenderFns = []

export { render, staticRenderFns }